const menus = [
  {
    'context': [
      'points',
      'cash'
    ],
    'items': [
      {
        'items': [],
        'label': 'Automotivo',
        'path': '/search?category=2',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Bebês',
        'path': '/search?category=3',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Bem estar',
        'path': '/search?category=4',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Casa e cozinha',
        'path': '/search?category=5',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Eletrônicos',
        'path': '/search?category=6',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Gastronomia',
        'path': '/search?category=13',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Indústria e Comércio',
        'path': '/search?category=1',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Lazer e Cultura',
        'path': '/search?category=7',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Moda',
        'path': '/search?category=8',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Todos',
        'path': '/categories',
        'enabled': true
      }
    ],
    'label': 'Categorias',
    'enabled': true,
    'type': 'services'
  },
  {
    'context': [
      'points',
      'cash'
    ],
    'items': [
      {
        'items': [],
        'label': 'C&C - Virtual',
        'path': '/vendor?vendor=21248',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Carrefour - Físico',
        'path': '/vendor?vendor=21210',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Carrefour - Virtual',
        'path': '/vendor?vendor=21109',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Cartão Presente Havan - Físico',
        'path': '/vendor?vendor=61792',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Casas Bahia - Virtual',
        'path': '/vendor?vendor=21112',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Cestas Michelli - Virtual',
        'path': '/vendor?vendor=21110',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Deezer - Físico',
        'path': '/vendor?vendor=51483',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Todos',
        'path': '/stores/vouchers',
        'enabled': true
      }
    ],
    'label': 'Vale Compras',
    'enabled': true,
    'type': 'services'
  },
  {
    'context': [
      'points',
      'cash'
    ],
    'items': [
      {
        'items': [],
        'label': 'Americanas',
        'path': '/vendor?vendor=61982',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Casas Bahia',
        'path': '/vendor?vendor=60',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Extra.Com',
        'path': '/vendor?vendor=59',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Fast Shop',
        'path': '/vendor?vendor=106',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Magazine Luiza',
        'path': '/vendor?vendor=62',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Ponto Frio',
        'path': '/vendor?vendor=58',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Todos',
        'path': '/stores',
        'enabled': true
      }
    ],
    'label': 'Lojas',
    'enabled': true,
    'type': 'services'
  },
  {
    'context': [
      'points',
      'cash'
    ],
    'items': [
      {
        'items': [],
        'label': 'Crédito em combustível',
        'path': '/fuelcredit',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Pague suas contas',
        'path': '/billpayment',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Recarga de celular',
        'path': '/mobile-recharge',
        'enabled': true
      }
    ],
    'label': 'Serviços',
    'enabled': true,
    'type': 'services'
  }
]

export default menus



// WEBPACK FOOTER //
// ./src/redux/initial-state/categoryMenu.js